const DOWNLOAD_PRESCRIPTION = 'my-account/datalayer/download-prescription';
const downloadPrescription = ()=>({
        type: DOWNLOAD_PRESCRIPTION
    })
;

export { DOWNLOAD_PRESCRIPTION, downloadPrescription };
//# sourceMappingURL=actions.js.map
